<script setup lang="ts">
import { computed } from 'vue';
import { usePage, Link } from '@inertiajs/vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import { SharedPageProps } from '@/Types/inertia';
import { pageTitle } from '@/Composables/PageMeta';

pageTitle.value = "Error";

interface PageData extends SharedPageProps{
    data?:{
        status?: number;
        message?: string;
        exceptionType?:{
            code?: any,
            type?: string,
            title?: string,
        },
        trace?: any,
        isInertia?: boolean
    };
}
const page = usePage<PageData>();
console.log(page.props.data)
const errorClass = computed(() => {
    let c = ' ';
    if(page.props.data?.status){
        c += ' has-title ';
    }
    return c;
});
</script>

<template>
  <!-- <AppLayout title="Error"> -->
    <div class="d-flex-col-grow justify-center align-center global-error" :class="[errorClass]">
        <div v-if="page.props.data?.status" class="title">{{ page.props.data?.status }}</div>
        <div class="message" v-if="!page.props.data?.message">
            {{ page.props.data?.exceptionType?.title ?? 'Not Found' }}
        </div>
        <div class="desc">{{ page.props.data?.message ?? 'An error occured due to unknown reason, please try again.' }}</div>
    </div>
  <!-- </AppLayout> -->
</template>